// Shape & density (Phase 2a design controls). These resolve to CSS variables
// set on `.venue-app`; the `rounded-*` utilities across the app point at the
// radius vars (see scripts/shape-codemod), and VenueShell's horizontal padding
// reads --app-pad. Absent config => the "rounded" + "inset" values below,
// which reproduce today's exact look (rounded-lg = 0.5rem, px-4 = 1rem).

import type { CSSProperties } from "react";

export type ShapeConfig = {
  radius?: "sharp" | "rounded" | "soft";
  density?: "inset" | "full";
};

// sm ≈ old rounded-md, base ≈ rounded-lg, lg ≈ rounded-xl, scaled together so
// the visual hierarchy is preserved at every roundedness.
const RADII = {
  sharp: { sm: "0.125rem", base: "0.1875rem", lg: "0.25rem" },
  rounded: { sm: "0.375rem", base: "0.5rem", lg: "0.75rem" },
  soft: { sm: "0.625rem", base: "1rem", lg: "1.25rem" },
} as const;

export function shapeVars(cfg?: ShapeConfig): CSSProperties {
  const r = RADII[cfg?.radius ?? "rounded"];
  const pad = (cfg?.density ?? "inset") === "full" ? "0rem" : "1rem";
  return {
    "--radius-sm": r.sm,
    "--radius": r.base,
    "--radius-lg": r.lg,
    "--app-pad": pad,
  } as CSSProperties;
}

// Pixel radii for the live preview (it uses inline styles, not Tailwind).
export function previewRadii(cfg?: ShapeConfig): { sm: number; card: number } {
  switch (cfg?.radius ?? "rounded") {
    case "sharp":
      return { sm: 2, card: 3 };
    case "soft":
      return { sm: 14, card: 20 };
    default:
      return { sm: 8, card: 12 };
  }
}
